import { jsx as _jsx } from "react/jsx-runtime";
import { usePlotContext } from '../../hooks';
import BottomAxis from './BottomAxis';
import BottomLogAxis from './BottomLogAxis';
import LeftAxis from './LeftAxis';
import LeftLogAxis from './LeftLogAxis';
import RightAxis from './RightAxis';
import RightLogAxis from './RightLogAxis';
import TopAxis from './TopAxis';
import TopLogAxis from './TopLogAxis';
function parallelPosition(position) {
    switch (position) {
        case 'bottom': {
            return 'top';
        }
        case 'top': {
            return 'bottom';
        }
        case 'left': {
            return 'right';
        }
        case 'right': {
            return 'left';
        }
        default: {
            throw new Error(`Unknown position ${position}`);
        }
    }
}
export default function ParallelAxis({ id, fontSize = 16, labelSpace = 24, hidden = false, tickStyle = {}, tickLength = 6, ...props }) {
    const { axisContext } = usePlotContext();
    // Don't display axis if parent id not in context
    const parentAxis = axisContext[id];
    if (!parentAxis)
        return null;
    // Get position oposite to parent axis
    const position = parallelPosition(parentAxis.position);
    const existing = Object.values(axisContext).find((axis) => axis.position === position);
    if (existing)
        throw new Error(`Position ${position} was already declared`);
    // Renders accordly to position and scale
    const { type } = parentAxis;
    const childProps = {
        id,
        fontSize,
        labelSpace,
        hidden,
        tickStyle,
        tickLength,
        ...props,
    };
    switch (`${position}-${type}`) {
        case 'top-log':
            return _jsx(TopLogAxis, Object.assign({}, childProps), void 0);
        case 'top-linear':
            return _jsx(TopAxis, Object.assign({}, childProps), void 0);
        case 'bottom-log':
            return _jsx(BottomLogAxis, Object.assign({}, childProps), void 0);
        case 'bottom-linear':
            return _jsx(BottomAxis, Object.assign({}, childProps), void 0);
        case 'left-log':
            return _jsx(LeftLogAxis, Object.assign({}, childProps), void 0);
        case 'left-linear':
            return _jsx(LeftAxis, Object.assign({}, childProps), void 0);
        case 'right-log':
            return _jsx(RightLogAxis, Object.assign({}, childProps), void 0);
        case 'right-linear':
            return _jsx(RightAxis, Object.assign({}, childProps), void 0);
        default:
            return null;
    }
}
//# sourceMappingURL=ParallelAxis.js.map